import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { Tooltip } from '#/shared/ui/tooltip'

import type { CallDisabledReason } from '../model/use-phone-panel-call'

type Translate = ReturnType<typeof useTranslation>['t']

function reasonText(reason: CallDisabledReason, t: Translate): string {
  switch (reason) {
    case 'connecting':
      return t('phonePanel.callDisabled.connecting')
    case 'offline':
      return t('phonePanel.callDisabled.offline')
    case 'busy':
      return t('phonePanel.callDisabled.busy')
    case 'loadingLines':
      return t('phonePanel.callDisabled.loadingLines')
    case 'lineCannotCall':
      return t('phonePanel.callDisabled.lineCannotCall')
  }
}

/** Names the gate keeping a call button disabled — hover explains instead of
 *  the button just sitting grey. Renders children untouched once ready. */
export function CallDisabledHint({
  reason,
  children,
}: {
  reason: CallDisabledReason | null
  children: ReactNode
}) {
  const { t } = useTranslation()
  if (reason === null) return <>{children}</>
  return (
    <Tooltip content={reasonText(reason, t)}>
      {/* A disabled button swallows pointer events; the span hosts the hover. */}
      <span className="inline-flex">{children}</span>
    </Tooltip>
  )
}
